document.addEventListener('click', async function (e) {
  const el = e.target.closest("a[href*='/cart/']");
  if (!el) return;
  const href = el.getAttribute('href');

  if (href.includes('redirect=/checkout')) {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.assign(href);
    return;
  }

  if (href.includes('#drawer')) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const m = href.match(/\/cart\/(\d+):(\d+)/);
    if (!m) return;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(m[1]), quantity: Number(m[2]) })
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.getElementById('cart-drawer').show();
    } catch (err) {
      console.error('Add to cart failed', err);
      alert("Couldn't add to cart — please try again.");
    }
  }
}, true);

function initBuyButton(buttonId, variantId, redirectTo) {
  function setup() {
    const btn = document.getElementById(buttonId);
    if (!btn || btn.dataset.initialized) return;
    btn.dataset.initialized = "true";
    btn.addEventListener("click", async e => {
      e.preventDefault();
      e.stopPropagation();
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (redirectTo) {
          window.location.assign(redirectTo);
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        document.getElementById("cart-drawer").show();
      } catch (err) {
        console.error("Add to cart failed", err);
        alert("Couldn't add to cart — please try again.");
      }
    });
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", setup)
    : setup();
}

/* ---------------------------------------------------------------------------
   AUTO-WIRE LANDING PAGE BUTTONS

   Why this exists: landing pages wrap their initBuyButton() calls in
   window.addEventListener('load', ...). On a heavy page that event can be 12+
   seconds out (measured 12.3s on /pages/savor-this-with-3-wick-of-the-sea-candle),
   and until it fires every CTA is unwired — a click just follows the href and
   dumps the shopper on the cart page instead of opening the drawer.

   This wires any .sn-btn whose href carries a variant id, as soon as the DOM has
   it, without waiting for load. Both href shapes are recognised:
     /cart/add?id=51412220215569&quantity=1
     /cart/51412220215569:1

   It's idempotent — initBuyButton's own dataset.initialized guard means a button
   already wired by an inline script is skipped, so existing page scripts can stay
   or be deleted, either way.
--------------------------------------------------------------------------- */
(function () {
  function variantFromHref(href) {
    var m = href.match(/[?&]id=(\d+)/) || href.match(/\/cart\/(\d+)(?::|$)/);
    return m ? Number(m[1]) : null;
  }

  function wireAll() {
    var buttons = document.querySelectorAll('a.sn-btn[href*="/cart"], button.sn-btn[data-variant-id]');
    for (var i = 0; i < buttons.length; i++) {
      var el = buttons[i];
      if (el.dataset.initialized) continue;

      var variant = el.tagName === 'A'
        ? variantFromHref(el.getAttribute('href') || '')
        : Number(el.dataset.variantId);

      if (!variant) continue;
      if (!el.id) el.id = 'sn-auto-buy-' + i + '-' + variant;

      initBuyButton(el.id, variant);
    }
  }

  wireAll();

  // Catch buttons that arrive late (app blocks, section re-renders) for the first
  // 15 seconds, then stop.
  var ticks = 0;
  var timer = setInterval(function () {
    wireAll();
    if (++ticks > 60) clearInterval(timer);
  }, 250);

  document.addEventListener('DOMContentLoaded', wireAll);
  window.addEventListener('load', wireAll);
})();

/* Find a variant ID from a PDP: document.querySelector('[name="id"]')?.value */